import { render } from "./InventoryStatusesList.vue?vue&type=template&id=44a35b96"
import script from "./InventoryStatusesList.vue?vue&type=script&lang=js"
export * from "./InventoryStatusesList.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__